<h2 mat-dialog-title>
    {{ 'polls_settings.make_recurrent.title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10 pb-0 pt-4">
    <make-poll-reccurrent-form [poll]="poll"
                                [frequency]="data.frequency"
                                [context]="'simple'"
                                (onDurationValueChanged)="onDurationValueChanged($event)"></make-poll-reccurrent-form>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'Cancel' | translate}}</button>
    <button type="submit"
            class="btn btn-primary" 
            [disabled]="poll.duration <= 0"
            (click)="makeRecurrent()">{{'Validate' | translate}}</button>
</mat-dialog-actions>